import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
// import './mock'
import axios from 'axios'
import VueAxios from 'vue-axios'

const app = createApp(App)

app.use(store)
  .use(router)
  .use(ViewUIPlus)
  .use(VueAxios, axios)
  .mount('#app')
